// src/app/modules/Dashboard/_redux/dashboard/Crud.js
import axios from "axios";
import config from "../../../../config";

export const URL = config.URL;

export function getDangerZones(params = {}) {
  const query = new URLSearchParams(params).toString();
  return axios.get(`${config.URL}danger-zones/recent?${query}`);
  // return axios.get(`${config.URL}danger-zones/recent`);
}

// POST: Submit a user-reported incident
export function submitDangerZoneReport(data) {
  return axios.post(`${config.URL}danger-zones/report`, data);
}


// Update your existing addNewData to include the report type
export function addNewData(type, data, queryId) {
  if (type === 'submit_danger_zone') {
    return submitDangerZoneReport(data);
  }
}

// Update your existing findDatas to include the fetch type
export function findDatas(type, queryParams, paginationParams) {
  if (type === 'danger_zones') {
    return getDangerZones(paginationParams);
  }
}